import React from 'react';
import './Modal.css';

export default function Modal({ open, onClose, title, children, footer, width, zIndex }) {
  if (!open) return null;
  return (
    <div
      className="tm-ui-modal-overlay"
      style={zIndex ? { zIndex } : undefined}
      onClick={onClose}
    >
      <div
        className="tm-ui-modal-content"
        style={width ? { width } : undefined}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 10, flexShrink: 0 }}>{title}</div>
        <div className="tm-ui-modal-body">{children}</div>
        {footer && <div style={{ marginTop: 12, flexShrink: 0 }}>{footer}</div>}
      </div>
    </div>
  );
}
